import Swiper, {
	Autoplay,
	EffectFade,
	Lazy,
	Navigation,
	Pagination,
} from '../../node_modules/swiper/swiper.esm.js'

Swiper.use([Autoplay, EffectFade, Lazy, Navigation, Pagination])

/* eslint-disable */
const heroSwiper = new Swiper('.swiper-container', {
	loop: true,
	pagination: {
		el: '.c-hero__pagination',
		clickable: true,
	},
	navigation: {
		nextEl: '.c-hero__button--next',
		prevEl: '.c-hero__button--prev',
	},
	effect: 'fade',
	autoplay: {
		delay: 10000,
	},
	lazy: {
		loadPrevNext: true,
		loadOnTransitionStart: true,
	},
})

const heroVideos = document.querySelectorAll('.js-video-embed');

if (heroVideos) {
	var tag = document.createElement('script');
	tag.id = 'iframe-demo';
	tag.src = 'https://www.youtube.com/iframe_api';
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


	heroVideos.forEach((item) => {
		item.addEventListener('click', onYouTubeIframeAPIReady)
	})


	var player;
	function onYouTubeIframeAPIReady() {
		var elems1 = document.querySelectorAll('.js-video-embed iframe');
		for(var i = 0; i < elems1.length; i++) {

			player = new YT.Player(elems1[i], {
				events: {
					//'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			});
		}
	}

	function onPlayerReady(event) {
	}

	function handleVideo(playerStatus) {
		if (playerStatus == -1) {
			// unstarted
			heroSwiper.autoplay.stop();
		} else if (playerStatus == 0) {
			// ended
			heroSwiper.autoplay.start();
		} else if (playerStatus == 1) {
			// playing = green                
			heroSwiper.autoplay.stop();  
		} else if (playerStatus == 2) {
			// paused = red
			heroSwiper.autoplay.start();
		} else if (playerStatus == 3) {
			// buffering = purple
		} else if (playerStatus == 5) {
			// video cued
		}
	}

	function onPlayerStateChange(event) {
		handleVideo(event.data);
	}

	const youtubeVideo = document.querySelectorAll('.js-video-embed iframe')
	const videos = document.querySelectorAll('.js-video-tag')

	heroSwiper.on('slideChange', function () {
		const currentSlide = heroSwiper.slides[heroSwiper.activeIndex]
		if (youtubeVideo) {
			youtubeVideo.forEach((item) => {
				item.contentWindow.postMessage(
					'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
					'*'
				)
			})
		}

		// Pause video on slide out and play on slide in
		if (videos) {
			videos.forEach(function(item) {
				item.pause()
			})
			if (currentSlide.hasAttribute('data-swiper-autoplay')) {
				const video = currentSlide.querySelector('video')
				video.load()
				video.play()
			}
		} 
	})
}